import { render, staticRenderFns } from "./SetNewPasswordPage.vue?vue&type=template&id=f7419338&scoped=true&"
import script from "./SetNewPasswordPage.vue?vue&type=script&lang=js&"
export * from "./SetNewPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7419338",
  null
  
)

export default component.exports